import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./style.css"
import { Helmet } from "react-helmet-async";
import NavbarTop from "../../components/NavbarTop";
import { PACOCA_URL } from "../../global-components/src/utils/vars";

const NotFound: React.FC = () => {
  const location = useLocation();
  const url = PACOCA_URL + location.pathname.replace("/*", "");
  
  useEffect(() => {
        const root = document.getElementById("root");
        if (root) root.style.overflow = "hidden";
    
        return () => {
            if (root) root.style.overflow = "";
        };
    }, []);

  return (
      <>
        <NavbarTop/>
        <div className="container-404">
            <Helmet>
              <title>Paçoca - 404</title>
            </Helmet>
            
          <div className="col d-flex" style={{alignItems: "center", flexDirection: "column"}}>
              <h1 className="title-bold">404</h1>
              <h3 style={{textAlign: "center"}}>Página não encontrada <br /></h3>
              <img src="/img/errors/page-not-found.jpg" className="img-page-not-found"></img>
              <Link to="/">Voltar para a Home</Link>
            </div>
        </div>
      </>
  );
};

export default NotFound;